module.exports = __webpack_public_path__ + "loading.70682a8c8a39dbf2cc05.gif";


//////////////////
// WEBPACK FOOTER
// /Users/mohammed/Desktop/OldLaptop/www-data/www-data/htdocs/remoteApi-front/ng-app/src/assets/images/loading.gif
// module id = ../../../../../src/assets/images/loading.gif
// module chunks = styles